import { styled } from "@mui/material/styles";

import { CheckerboardBackground } from "@/components/ui-v2/Backgrounds/Checkerboard";

import { classes } from "./constants";

interface GalleryImagePreviewSimpleProps {
  src: string;
  srcSet: string;
  aspectRatio: string;
}
const StyledImg = styled("img")({
  position: "relative",
  display: "block",
  objectFit: "contain",
  maxWidth: "100%",
  maxHeight: "100%",
  pointerEvents: "none",
});

export const GalleryImagePreviewSimple = (
  props: GalleryImagePreviewSimpleProps,
) => {
  const { src, srcSet, aspectRatio } = props;
  return (
    <CheckerboardBackground
      sx={{
        position: "absolute",
        inset: 0,
        margin: "auto",
        aspectRatio,
        maxWidth: "100%",
        maxHeight: "100%",
      }}
    >
      <StyledImg
        src={src}
        srcSet={srcSet}
        draggable={false}
        alt="Preview"
        className={classes.image}
      />
    </CheckerboardBackground>
  );
};
